export default __webpack_public_path__ + "static/media/tab04_title01.9d462ace.png";